import React, { Component } from 'react'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import '../../../../../node_modules/react-datepicker/dist/react-datepicker.css'

export default function DateRangeFilter({ interval, selectedStartDate, selectedEndDate, handleChangeStart, handleChangeEnd, quickDate, handleQuickDate, singleDate, timeSelect = false, monthSelect = false }) {
    return (
        <React.Fragment>
            <div>
                {!singleDate && !monthSelect && (
                    <div className="mr-2">
                        <select className="custom-select custom-select-sm" onChange={handleQuickDate} value={quickDate}>
                            <option value="today">Today</option>
                            <option value="yesterday">Yesterday</option>
                            <option value="month">This Month</option>
                            <option value="lastMonth">Last Month</option>
                            <option value="thisYear">This Year</option>
                            <option value="thisPayPeriod">This Pay Period</option>
                            <option value="lastPayPeriod">Last Pay Period</option>
                            <option value="custom">Custom Date</option>
                        </select>
                    </div>
                )}
            </div>
            {!singleDate && (quickDate === 'custom' || monthSelect) && (
                <div className="d-flex mr-2">
                    <DatePicker
                        showTimeSelect={timeSelect}
                        selectsStart /* To signify it's the "start" picker */
                        selected={selectedStartDate ? moment(selectedStartDate).toDate() : null}
                        startDate={selectedStartDate ? moment(selectedStartDate).toDate() : null}
                        endDate={selectedEndDate ? moment(selectedEndDate).toDate() : null}
                        onChange={(date) => {
                            handleChangeStart(date)
                            console.log('date1', date, timeSelect)
                        }}
                        className="form-control form-control-sm display-inline-block mr-2"
                        todayButton={'Today'}
                        timeFormat="HH:mm"
                        timeIntervals={interval}
                        dateFormat={monthSelect ? "MM/yyyy" : (timeSelect ? "yyyy-MM-dd h:mm aa" : "yyyy-MM-dd")}
                        showMonthYearPicker={monthSelect}
                    />
                    <div className="d-flex mx-2 align-items-center">to</div>
                    <DatePicker
                        showTimeSelect={timeSelect}
                        selectsEnd /* To signify it's the "end" picker */
                        selected={selectedEndDate ? moment(selectedEndDate).toDate() : null}
                        startDate={selectedStartDate ? moment(selectedStartDate).toDate() : null}
                        endDate={selectedEndDate ? moment(selectedEndDate).toDate() : null}
                        onChange={(date) => {
                            handleChangeEnd(date)
                            console.log('date2', date, timeSelect)
                        }}
                        className="form-control form-control-sm display-inline-block mr-2"
                        todayButton={'Today'}
                        timeFormat="HH:mm"
                        timeIntervals={interval}
                        dateFormat={monthSelect ? "MM/yyyy" : (timeSelect ? "yyyy-MM-dd h:mm aa" : "yyyy-MM-dd")}
                        showMonthYearPicker={monthSelect}
                    />
                </div>
            )}

            {singleDate && (
                <div className="d-flex mr-2">
                    <DatePicker
                        showTimeSelect={timeSelect}
                        selectsStart /* To signify it's the "start" picker */
                        selected={selectedStartDate ? moment(selectedStartDate).toDate() : null}
                        startDate={selectedStartDate ? moment(selectedStartDate).toDate() : null}
                        endDate={selectedEndDate ? moment(selectedEndDate).toDate() : null}
                        onChange={(date) => {
                            handleChangeStart(date)
                        }}
                        className="form-control form-control-sm display-inline-block mr-2"
                        todayButton={'Today'}
                        timeFormat="HH:mm"
                        timeIntervals={interval}
                        dateFormat={monthSelect ? "MM/yyyy" : (timeSelect ? "yyyy-MM-dd h:mm aa" : "yyyy-MM-dd")}
                    />
                </div>
            )}
        </React.Fragment>
    )
}
